import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, Transition as _Transition, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, normalizeClass as _normalizeClass, withDirectives as _withDirectives, renderSlot as _renderSlot, vShow as _vShow, createSlots as _createSlots, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: "select-trigger" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "el-select__tags-text" }
const _hoisted_4 = ["disabled", "autocomplete"]
const _hoisted_5 = { style: {"height":"100%","display":"flex","justify-content":"center","align-items":"center"} }
const _hoisted_6 = {
  key: 1,
  class: "el-select-dropdown__empty"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_select_menu = _resolveComponent("el-select-menu")!
  const _component_el_popper = _resolveComponent("el-popper")!
  const _directive_loading = _resolveDirective("loading")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    ref: "selectWrapper",
    class: _normalizeClass(["el-select", [_ctx.selectSize ? 'el-select--' + _ctx.selectSize : '']]),
    onClick: _cache[25] || (_cache[25] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleMenu && _ctx.toggleMenu(...args)), ["stop"]))
  }, [
    _createVNode(_component_el_popper, {
      ref: "popper",
      visible: _ctx.dropMenuVisible,
      "onUpdate:visible": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.dropMenuVisible) = $event)),
      placement: "bottom-start",
      "append-to-body": _ctx.popperAppendToBody,
      "popper-class": `el-select__popper ${_ctx.popperClass}`,
      "fallback-placements": ['auto'],
      "manual-mode": "",
      effect: "light",
      pure: "",
      trigger: "click",
      offset: 0,
      transition: "el-zoom-in-top",
      "stop-popper-mouse-event": false,
      "gpu-acceleration": false,
      "same-width": _ctx.sameWidth,
      onBeforeEnter: _ctx.handleMenuEnter
    }, {
      trigger: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          (_ctx.multiple)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                ref: "tags",
                class: "el-select__tags",
                style: _normalizeStyle({ 'max-width': _ctx.inputWidth - 32 + 'px', width: '100%' })
              }, [
                (_ctx.collapseTags && _ctx.selected.length)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
                      _createVNode(_component_el_tag, {
                        closable: !_ctx.selectDisabled && !_ctx.selected[0].isDisabled,
                        size: _ctx.collapseTagSize,
                        hit: _ctx.selected[0].hitState,
                        type: "info",
                        "disable-transitions": "",
                        onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.deleteTag($event, _ctx.selected[0])))
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", {
                            class: "el-select__tags-text",
                            style: _normalizeStyle({ 'max-width': _ctx.inputWidth - 123 + 'px' })
                          }, _toDisplayString(_ctx.selected[0].currentLabel), 5)
                        ]),
                        _: 1
                      }, 8, ["closable", "size", "hit"]),
                      (_ctx.selected.length > 1)
                        ? (_openBlock(), _createBlock(_component_el_tag, {
                            key: 0,
                            closable: false,
                            size: _ctx.collapseTagSize,
                            type: "info",
                            "disable-transitions": ""
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", _hoisted_3, "+ " + _toDisplayString(_ctx.selected.length - 1), 1)
                            ]),
                            _: 1
                          }, 8, ["size"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.collapseTags)
                  ? (_openBlock(), _createBlock(_Transition, {
                      key: 1,
                      onAfterLeave: _ctx.resetInputHeight
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", {
                          style: _normalizeStyle({marginLeft: _ctx.prefixWidth && _ctx.selected.length ? `${_ctx.prefixWidth}px` : null})
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selected, (item) => {
                            return (_openBlock(), _createBlock(_component_el_tag, {
                              key: _ctx.getValueKey(item),
                              closable: !_ctx.selectDisabled && !item.isDisabled,
                              size: _ctx.collapseTagSize,
                              hit: item.hitState,
                              "custom-tag": true,
                              type: "info",
                              "disable-transitions": "",
                              onClose: ($event: any) => (_ctx.deleteTag($event, item))
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", {
                                  class: "el-select__tags-text inline-block overflow-hidden overflow-ellipsis align-bottom",
                                  style: _normalizeStyle({ 'max-width': _ctx.inputWidth - 75 + 'px' })
                                }, _toDisplayString(item.currentLabel), 5)
                              ]),
                              _: 2
                            }, 1032, ["closable", "size", "hit", "onClose"]))
                          }), 128))
                        ], 4)
                      ]),
                      _: 1
                    }, 8, ["onAfterLeave"]))
                  : _createCommentVNode("", true),
                (_ctx.filterable)
                  ? _withDirectives((_openBlock(), _createElementBlock("input", {
                      key: 2,
                      ref: "input",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.query) = $event)),
                      type: "text",
                      class: _normalizeClass(["el-select__input", [_ctx.selectSize ? `is-${ _ctx.selectSize }` : '']]),
                      disabled: _ctx.selectDisabled,
                      autocomplete: _ctx.autocomplete,
                      style: _normalizeStyle({ marginLeft: _ctx.prefixWidth && !_ctx.selected.length || _ctx.tagInMultiLine ? `${_ctx.prefixWidth}px` : null, flexGrow: '1', width: `${_ctx.inputLength / (_ctx.inputWidth - 32)}%`, maxWidth: `${_ctx.inputWidth - 42}px` }),
                      onFocus: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleFocus && _ctx.handleFocus(...args))),
                      onBlur: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleBlur && _ctx.handleBlur(...args))),
                      onKeyup: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.managePlaceholder && _ctx.managePlaceholder(...args))),
                      onKeydown: [
                        _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.resetInputState && _ctx.resetInputState(...args))),
                        _cache[6] || (_cache[6] = _withKeys(_withModifiers(($event: any) => (_ctx.navigateOptions('next')), ["prevent"]), ["down"])),
                        _cache[7] || (_cache[7] = _withKeys(_withModifiers(($event: any) => (_ctx.navigateOptions('prev')), ["prevent"]), ["up"])),
                        _cache[8] || (_cache[8] = _withKeys(_withModifiers(($event: any) => (_ctx.visible = false), ["stop","prevent"]), ["esc"])),
                        _cache[9] || (_cache[9] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.selectOption && _ctx.selectOption(...args)), ["stop","prevent"]), ["enter"])),
                        _cache[10] || (_cache[10] = _withKeys(
//@ts-ignore
(...args) => (_ctx.deletePrevTag && _ctx.deletePrevTag(...args)), ["delete"])),
                        _cache[11] || (_cache[11] = _withKeys(($event: any) => (_ctx.visible = false), ["tab"]))
                      ],
                      onCompositionstart: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.handleComposition && _ctx.handleComposition(...args))),
                      onCompositionupdate: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.handleComposition && _ctx.handleComposition(...args))),
                      onCompositionend: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.handleComposition && _ctx.handleComposition(...args))),
                      onInput: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.debouncedQueryChange && _ctx.debouncedQueryChange(...args)))
                    }, null, 46, _hoisted_4)), [
                      [_vModelText, _ctx.query]
                    ])
                  : _createCommentVNode("", true)
              ], 4))
            : _createCommentVNode("", true),
          _createVNode(_component_el_input, {
            id: _ctx.id,
            ref: "reference",
            modelValue: _ctx.selectedLabel,
            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.selectedLabel) = $event)),
            type: "text",
            placeholder: _ctx.currentPlaceholder,
            name: _ctx.name,
            autocomplete: _ctx.autocomplete,
            size: _ctx.selectSize,
            disabled: _ctx.selectDisabled,
            readonly: _ctx.readonly,
            "validate-event": false,
            class: _normalizeClass({ 'is-focus': _ctx.visible }),
            tabindex: (_ctx.multiple && _ctx.filterable) ? '-1' : null,
            onFocus: _ctx.handleFocus,
            onBlur: _ctx.handleBlur,
            onInput: _ctx.debouncedOnInputChange,
            onPaste: _ctx.debouncedOnInputChange,
            onKeydown: [
              _cache[18] || (_cache[18] = _withKeys(_withModifiers(($event: any) => (_ctx.navigateOptions('next')), ["stop","prevent"]), ["down"])),
              _cache[19] || (_cache[19] = _withKeys(_withModifiers(($event: any) => (_ctx.navigateOptions('prev')), ["stop","prevent"]), ["up"])),
              _withKeys(_withModifiers(_ctx.selectOption, ["stop","prevent"]), ["enter"]),
              _cache[20] || (_cache[20] = _withKeys(_withModifiers(($event: any) => (_ctx.visible = false), ["stop","prevent"]), ["esc"])),
              _cache[21] || (_cache[21] = _withKeys(($event: any) => (_ctx.visible = false), ["tab"]))
            ],
            onMouseenter: _cache[22] || (_cache[22] = ($event: any) => (_ctx.inputHovering = true)),
            onMouseleave: _cache[23] || (_cache[23] = ($event: any) => (_ctx.inputHovering = false))
          }, _createSlots({
            suffix: _withCtx(() => [
              _withDirectives(_createElementVNode("i", {
                class: _normalizeClass(['el-select__caret', 'el-input__icon', 'el-icon-' + _ctx.iconClass])
              }, null, 2), [
                [_vShow, !_ctx.showClose]
              ]),
              (_ctx.showClose)
                ? (_openBlock(), _createElementBlock("i", {
                    key: 0,
                    class: _normalizeClass(`el-select__caret el-input__icon ${_ctx.clearIcon}`),
                    onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.handleClearClick && _ctx.handleClearClick(...args)))
                  }, null, 2))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, [
            (_ctx.$slots.prefix)
              ? {
                  name: "prefix",
                  fn: _withCtx(() => [
                    _createElementVNode("div", _hoisted_5, [
                      _renderSlot(_ctx.$slots, "prefix")
                    ])
                  ])
                }
              : undefined
          ]), 1032, ["id", "modelValue", "placeholder", "name", "autocomplete", "size", "disabled", "readonly", "class", "tabindex", "onFocus", "onBlur", "onInput", "onPaste", "onKeydown"])
        ])
      ]),
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createBlock(_component_el_select_menu, null, {
          default: _withCtx(() => [
            _withDirectives(_createVNode(_component_el_scrollbar, {
              ref: "scrollbar",
              tag: "ul",
              "wrap-class": "el-select-dropdown__wrap",
              "view-class": "el-select-dropdown__list",
              class: _normalizeClass({ 'is-empty': !_ctx.allowCreate && _ctx.query && _ctx.filteredOptionsCount === 0 }),
              onScroll: _ctx.onScroll
            }, {
              default: _withCtx(() => [
                (_ctx.showNewOption)
                  ? (_openBlock(), _createBlock(_component_el_option, {
                      key: 0,
                      value: _ctx.query,
                      created: true
                    }, null, 8, ["value"]))
                  : _createCommentVNode("", true),
                _renderSlot(_ctx.$slots, "default")
              ]),
              _: 3
            }, 8, ["class", "onScroll"]), [
              [_vShow, _ctx.options.size > 0]
            ]),
            (_ctx.emptyText && (!_ctx.allowCreate || (_ctx.allowCreate && _ctx.options.size === 0 )))
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (_ctx.$slots.empty)
                    ? _renderSlot(_ctx.$slots, "empty", { key: 0 })
                    : (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.emptyText), 1))
                ], 64))
              : _createCommentVNode("", true)
          ]),
          _: 3
        })), [
          [_directive_loading, _ctx.loading]
        ])
      ]),
      _: 3
    }, 8, ["visible", "append-to-body", "popper-class", "same-width", "onBeforeEnter"])
  ], 2)), [
    [_directive_click_outside, _ctx.handleClose, _ctx.popperPaneRef]
  ])
}